<template>
  <v-table
    :count="count"
    :list="list"
    :query-list="queryList"
    :is-loading="isLoading"
    :push-list="RouteConfig.courseStyleDeletedList.push"
    :is-show-search-input="true"
    search-placeholder="输入舞蹈风格名称进行搜索"
  >
    <v-column-time value="删除时间" field="is_del"/>
    <v-column-time value="修改时间" field="update_time" sortable=""/>
    <el-table-column label="ID" prop="id"/>
    <el-table-column label="舞蹈风格名称" prop="style_name"/>

    <el-table-column v-if="isAdministrator" width="210px" label="操作">
      <template v-slot="{ row }">

        <v-list-button :to="RouteConfig.courseStyleEdit.to(row.id)"/>

        <v-list-button
          name="恢复"
          icon="restore"
          @click="handleDelete(row)"
          :is-loading="isDeleting[row.id]"
          message="确定要恢复此舞蹈风格吗？"
          :is-last="true"
        />
      </template>
    </el-table-column>

    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`card-ticket-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>删除时间</span>
              <span>{{ v.is_del | timeToYmdHi }}</span>
            </div>

            <div class="list-item-detail">
              <span>添加时间</span>
              <span>{{ v.add_time | timeToYmdHi }}</span>
            </div>

            <div class="list-item-detail">
              <span>修改时间</span>
              <span>{{ v.update_time | timeToYmdHi }}</span>
            </div>

            <div class="list-item-detail">
              <span>ID</span>
              <span>{{ v.id }}</span>
            </div>

            <div class="list-item-detail">
              <span>舞蹈风格名称</span>
              <span>{{ v.style_name }}</span>
            </div>

            <div class="list-item-button">
              <template v-if="isAdministrator">
                <v-list-button :to="RouteConfig.courseStyleEdit.to(v.id)"/>

                <v-list-button
                  name="删除"
                  icon="bin"
                  @click="handleDelete(v)"
                  :is-loading="isDeleting[v.id]"
                  message="确定要删除此风格吗？"
                  :is-last="true"
                />
              </template>
            </div>
          </div>
        </template>

        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>
</template>

<script>
import RouteConfig from '@/router/config';
import { mapGetters } from 'vuex';
import { getLegalQueryList } from '@/utils/formats';
import { index, restore } from '@/api/course-style';

export default {
  name: RouteConfig.courseStyleDeletedList.name,
  data: () => ({
    RouteConfig,
    isLoading: false,
    isDeleting: {},
    count: 0,
    list: [],
    queryList: {
      keyword: '',
      store_id: '',
      is_asc: 0,
      page: 1,
      size: 10,
    },
  }),
  computed: {
    ...mapGetters([
      'isAdministrator',
    ]),
  },
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  beforeMount() {
    this.load();
  },
  methods: {
    async load(route = this.$route, next) {
      const { queryList } = this;
      getLegalQueryList(queryList, route.query);

      const { ...params } = queryList;
      params.is_del = 1;

      this.isLoading = true;
      const { isError, data } = await index(params);
      this.isLoading = false;
      if (isError) return;

      this.count = data.count;
      this.list = data.list;
      if (next) next();
    },
    async handleDelete({ id, update_time}) {
      if (this.isDeleting[id]) return;
      if (!id) return this.$message.warning('缺少舞蹈风格 ID，无法恢复该舞蹈风格！');
      if (!Number.isInteger(update_time) || update_time < 0) return this.$message.error('缺少舞蹈风格信息，无法恢复！');

      this.$set(this.isDeleting, id, true);
      const { isError } = await restore(id, { update_time });
      this.$set(this.isDeleting, id, false);
      if (!isError) this.load();
    },
  },
};
</script>
